<template>
  <div class="page-container">
    <div class="page-card">
      <div class="card-header">
        <h3>小程序审核模式配置</h3>
        <p class="tip">关闭审核模式后，小程序首页隐藏搜索框、轮播、每日科普资讯，同时全局隐藏底部TabBar</p>
      </div>
      <el-form ref="form" :model="formData" label-width="160px">
        <el-form-item label="审核模式">
          <el-switch
            v-model="formData.audit_mode"
            :active-value="1"
            :inactive-value="0"
            active-text="开启(小程序审核时开启)"
            inactive-text="关闭(正常使用)"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存配置</el-button>
          <el-button @click="loadConfig">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// Vue2 直接引入qs
import qs from 'qs'
export default {
  name: "AuditMode",
  data() {
    return {
      formData: {
        audit_mode: 1
      },
      submitLoading: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    // 获取配置
    async loadConfig() {
      try {
        const res = await this.$request.get("/action.php", {
          params: { act: "getAuditMode" }
        });
        console.log("完整返回res：", res)
        if (res.code === 200) {
          const val = res.data.audit_mode
          console.log("audit原始值：", val, typeof val)
          this.formData.audit_mode = Number(val);
          console.log("赋值后：", this.formData.audit_mode)
        } else {
          this.$message.error(res.msg || "读取配置失败");
        }
      } catch (err) {
        console.error(err)
        this.$message.error("网络请求异常");
      }
    },
    // 保存【方案一：仅当前接口转为form表单提交，适配PHP $_POST】
    async submitForm() {
      this.submitLoading = true;
      try {
        // qs序列化，转成 urlencoded 表单字符串
        const postData = qs.stringify({
          act: "saveAuditMode",
          audit_mode: this.formData.audit_mode
        })
        const res = await this.$request.post(
          "/action.php",
          postData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        if (res.code === 200) {
          this.$message.success("保存成功！小程序完全关闭重进生效");
          this.loadConfig();
        } else {
          this.$message.error(res.msg || "保存失败");
        }
      } catch (err) {
        this.$message.error("网络请求异常");
      } finally {
        this.submitLoading = false;
      }
    }
  }
}
</script>
<style scoped>
.page-container {
  padding: 24px;
  background: #f7f8fa;
  min-height: 100%;
}
.page-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  max-width: 700px;
}
.card-header {
  margin-bottom: 24px;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
}
.card-header h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
}
.tip {
  color: #909399;
  font-size: 13px;
  margin: 8px 0 0;
}
</style>
